import I18n from 'I18n';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import styled from 'styled-components';
import TranslatedFeature from './TranslatedFeature';
import { MinusIcon } from 'foundations-assets/icons/components/MinusIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureTableCellWrapper = styled.td.withConfig({
  displayName: "FeatureTableCell__FeatureTableCellWrapper"
})(({
  theme
}) => ({
  padding: `${theme.space['300']}`
}));
const SuccessCheckDiv = styled.div.withConfig({
  displayName: "FeatureTableCell__SuccessCheckDiv"
})(({
  theme
}) => ({
  fontSize: `${theme.space['250']} !important`
}));
const ScreenReaderFeatureLabel = styled.span.withConfig({
  displayName: "FeatureTableCell__ScreenReaderFeatureLabel"
})(({
  theme
}) => ({
  position: 'absolute !important',
  top: `${theme.space['0']} !important`,
  width: `${theme.space['25']} !important`,
  height: `${theme.space['25']} !important`,
  padding: `${theme.space['0']} !important`,
  overflow: 'hidden !important',
  clip: 'rect(0, 0, 0, 0) !important'
}));
const FeatureTableCell = ({
  feature,
  apiName
}) => {
  const hasDefaultLimit = Object.keys(feature.shouldUseDefaultLimits).some(key => key.includes(apiName || ''));
  const hasShortLimit = Object.keys(feature.shortLimits).some(key => key.includes(apiName || '') && !!feature.shortLimits[key]);
  const featureAvailable = hasDefaultLimit || hasShortLimit;
  if (!apiName || !featureAvailable) return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: /*#__PURE__*/_jsx(MinusIcon, {
      "aria-label": I18n.text('upgrades.featureTable.screenReader.featureUnavailable')
    })
  });
  return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: hasShortLimit ? /*#__PURE__*/_jsx("div", {
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(TranslatedFeature, {
        apiName: apiName,
        feature: feature,
        attribute: "shortLimits"
      })
    }) : /*#__PURE__*/_jsxs(SuccessCheckDiv, {
      children: [/*#__PURE__*/_jsx(IconCircle, {
        icon: SuccessIcon,
        color: "fill-surface-default",
        backgroundColor: "icon-core-default",
        borderWidth: "0"
      }), /*#__PURE__*/_jsx(ScreenReaderFeatureLabel, {
        children: I18n.text('upgrades.featureTable.screenReader.featureAvailable')
      })]
    })
  });
};
export default FeatureTableCell;